module.exports = __webpack_public_path__ + "static/media/bg2.eb67e0c6.jpg";